import { render } from "./CameroonTerms.vue?vue&type=template&id=21f74002"
import script from "./CameroonTerms.vue?vue&type=script&lang=js"
export * from "./CameroonTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__